import { render } from "./AlignerOrderUpdate.vue?vue&type=template&id=17877d14&scoped=true"
import script from "./AlignerOrderUpdate.vue?vue&type=script&lang=js"
export * from "./AlignerOrderUpdate.vue?vue&type=script&lang=js"

import "./AlignerOrderUpdate.vue?vue&type=style&index=0&id=17877d14&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17877d14"]])

export default __exports__